<template>
  <el-dialog
    :visible="!!Nodesid"
    title="查看节点新人"
    width="1200px"
    @close="closeDialog"
  >
    <div class="page-actions">
      <span>选择时间：</span>
      <el-date-picker
        v-model="times"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        format="yyyy 年 MM 月 dd 日"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
      <el-button type="primary" @click="serch()">查询</el-button>
    </div>
    <el-table :data="peopleList">
      <el-table-column label="注册时间">
        <template slot-scope="scope">
          <span>{{ scope.row.ctreateTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column label="用户ID" prop="userId"> </el-table-column>
      <el-table-column label="是否激活">
        <template slot-scope="scope">
          <span v-if="scope.row.activate">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column label="激活时间">
        <template slot-scope="scope">
          <span>{{ scope.row.activateTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column label="抢购次数" prop="foundationNum"> </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="ptoatl"
      @pageChanged="handleCurrentChange"
    >
    </pagination>
  </el-dialog>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import Pagination from 'components/pagination';

export default {
  name: 'nodepeople',
  data() {
    return {
      pagination: {
        page: 1,
        size: 10
      },
      times: []
    };
  },
  computed: {
    ...mapState('setnode', ['Nodesid', 'peopleList', 'ptoatl']),
    startTime() {
      return this.times ? this.times[0] : '';
    },
    endTime() {
      return this.times ? this.times[1] : '';
    }
  },
  watch: {
    Nodesid(val) {
      this.detail = { ...val };
    }
  },
  components: {
    Pagination
  },
  methods: {
    ...mapMutations('setnode', ['seeNodePeople']),
    ...mapActions('setnode', ['Newpeople']),
    closeDialog() {
      this.seeNodePeople(null);
    },
    handleCurrentChange(page) {
      this.pagination = page;
      this.Newpeople({ ...this.pagination, nodeId: this.Nodesid });
    },
    serch() {
      this.Newpeople({
        ...this.pagination,
        nodeId: this.Nodesid,
        startTime: this.startTime,
        endTime: this.endTime
      });
    }
  }
};
</script>
